/// <reference path="DOMAttached.js" />
/// <reference path="TextResource.js" />
/// <reference path="UrlTemplate.js" />

var TypingGuardianServerInterface = null;

class TypingGuardian extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		TypingGuardianServerInterface = this;
		var isMobile = /iPad|iPhone|iPod|Android|webOS|Windows Phone/.test(navigator.userAgent);

		if (isMobile) {
			confirmAI(options.mobileMessage,
				this.onMobileRedirect.bind(this), this.onMobileRedirect.bind(this),
				true, false, { confirmBtnCaption: this.options.mobileButtonText });
		}
	}

	onMobileRedirect() {
		window.location.href = this.options.mobileRedirectURL;
	}

	levelReachedRequest(level, score) {
		axios(new UrlTemplate(this.options.levelReachedURL).r('PLH_level', level).r('PLH_score', score).url, {
				method: 'get'
			}
		).then((response) => {
			var parsedResponse = response.data;
			var temp = new TypingGuardianClientInterface();
			temp.levelReachedResponse(parsedResponse.medal);
		});
	}

	getCurrentLevel() {
		return this.options.lastCompletedLevel;
	}

	getHighestMedalOnGameStart() {
		return this.options.highestAwardedMedal;
	}
}
